<script>
import { qrSecretComputed, qrSecretMethods } from '@state/qrCodeHelpers'
export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...qrSecretComputed,
    computedReSendMailSuccess() {
      return this.sendQrCodeSuccess
    },
    computedLoading() {
      return this.isLoadingSendQr && this.loading
    },
  },
  watch: {
    computedReSendMailSuccess() {
      this.loading = false
      this.$router.push({ path: `/booking-info/confirm-resend` })
    },
  },
  methods: {
    ...qrSecretMethods,
    handleResendQr() {
      this.loading = true
      const query = this.$route.query.token
      this.sendQrCode({ token: query })
    },
  },
}
</script>

<template>
  <div>
    <v-img
      :src="require('@assets/images/warning.png')"
      contain
      aspect-ratio="1.5"
      width="200"
      class="ma-auto"
    />
    <p class="white--text font-weight-bold my-10"> {{ $t('resendQr') }}</p>
    <BaseButtonMainCard
      label="再発行"
      :loading="computedLoading"
      @click="handleResendQr"
    />
  </div>
</template>

<style lang="scss">
@import '@design';
</style>
